import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent9: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">List next 10 customers</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    List next 10 customers
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In this step, you will identify 10 additional real high-potential customers that fit your end user profile. Hopefully, these real customers are well-represented by the persona. If not, then you will go back and rethink your persona from Step 5. After identifying the real customers, you will make contact to verify and refine your primary market research.

This step dramatically increases confidence that you are on the right path and, more than likely, also helps you refine earlier steps. While it is important to identify and develop a core persona to represent your end users, you must also be sure to identify other potential customers to ensure your product’s success. This will substantially validate that you have identified a scalable opportunity, not just a one-customer solution, and in so doing, increase your credibility to others. It also helps in directly testing every hypothesis built over the past eight steps and have more touch points to test future hypotheses going forward.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Identifying the next 10 customers
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In the process of determining the next 10 customers, you are testing to ensure your persona is truly a useful and credible representation of the target customer. If the Persona is a statistical outlier relative to the target customer group, it will not only be a poor source of information, but it will lead you to develop a “one customer” product which the rest your target customer community might not want. While validating the persona, you may also uncover other interesting traits that customers share with the persona, which will allow you to revise the description of the persona to make it stronger. Now:

Make a list of more than 10 potential customers and include any pertinent information that you have about them from your existing research.
Verify that the customers are similar to both each other and the Persona. If they are not, revisit the reasons a customer made it to the list of 10, and, the description of the Persona itself. (Do not worry if these change. The nature of the DE Toolbox is to allow you to pivot on paper before money is spent on ill-targeted marketing campaigns, or product build. Better to erase than have to destroy.)
Contact each of the potential customers on your list and present your Full Life Cycle Use Case, High-Level Product Specification, and Quantified Value Proposition (Steps 6–8). Make sure you’re operating in inquiry mode, not advocacy/sales mode, so that the outcome is useful.
Note whether the customer’s needs and ideas are in line with what you’ve established so far.
Focus on validating the hypotheses you have regarding the Persona’s top purchasing priorities.
Consolidate all the conclusions from the customer meetings and review all the assumptions.
If a customer validates your hypotheses from the previous steps, now is a good time to ask the customer if they would consider providing a letter of intent to buy your solution, once it is available.
Decide whether you need to contact additional customers to collect more data.
Review any assumptions or conclusions from the previous steps.
Review and refine the Persona, based on the 10 interviews.
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>
      
  );
};

export { StepContent9 };
